define('views/blocks/HeaderView',['underscore',
        'jquery',
        'backbone',
        'app',
        'hooks',
        'SubView',
        'TagCommander',
        'site_vars',
        'router',
        'InternalLinkView',
        'SelectView',
        'models/StoreLocatorSearchCollection',
        'template!blocks/main-header',
        'template!blocks/header-store-wrapper',
        'template!blocks/header-account-wrapper',
        'template!blocks/header-reorder-wrapper',
        'template!blocks/reorder-order-single',
        'template!blocks/stores/store-autocomplete-result',
        'AddressAutocompleteView',
        'views/blocks/ReorderOrderSingleView',
		'views/blocks/OrderTrackingView',
        'UI'
	],
    function (_,
              $,
              Backbone,
              app,
              hooks,
              SubView,
              TagCommander,
              site_vars,
              router,
              InternalLinkView,
              SelectView,
              StoreLocatorSearchCollection,
              mainHeaderTemplate,
              headerStoreWrapperTemplate,
              headerAccountWrapperTemplate,
              headerReorderWrapperTemplate,
              headerReorderSingleTemplate,
              StoreAutocompleteResultTemplate,
              AddressAutocompleteView,
              ReorderOrderSingleView,
              OrderTrackingView,
              UI
    ) {

    //
    // Header View
    //

    //
    // le header est un singleton,
    //
    var view,
        initialRender = true,
        storeLocatorSearchCollection = new StoreLocatorSearchCollection(),
        touchmoveY = false,
        touchmoveDeltaY = 0;

    return Backbone.View.extend(SubView).extend({

        el:'.site-header',
        events: {
            'click [data-link]':'trackLink',
            'click .burger': 'openSideNav',
            'click .open-autocomplete': 'openAutocomplete',
            'click .listing-link': 'clickListingLink',
            'mouseenter .wrapper-link': 'openWrapper',
            'touchstart .wrapper-link': 'openWrapper',
            'change select.lang-select' : 'switchLang',
            'mouseleave .header-wrapper': 'closeWrapper',
            'mouseenter .wrapper-overlay': 'closeWrapper',
            'mouseup .close-wrapper': 'closeWrapper',
            'touchmove .header-wrapper': 'touchmoveWrapper',
            'touchend .header-wrapper': 'touchendWrapper',
            'submit .header-store-search':'submitStoreSearch',
            'keyup .search-store-location':'inputChange',
            'change .search-store-location':'inputChange',
            'focusin .search-store-location':'inputFocus',
            'focusout .search-store-location':'inputFocusOut',
        },
        initialize:function(){

            view = this;
            view.subviews = [];
            view.listenTo(storeLocatorSearchCollection,'searchComplete sync reset',view.onSearchResults);
            storeLocatorSearchCollection.empty();

            view.render(false);

            var customer = app.getCustomer(), cart = app.getCart();

            view.listenTo(app,'hideHeader', view.hide);
            view.listenTo(app,'showHeader', view.show);
            view.listenTo(app,'pageChange', view.onPageChange);
            view.listenTo(cart,'deliveryUpdate change:store_closed',view.render);
            view.listenTo(cart,'productsChange',view.onChangeCartQuantity);
            view.listenTo(customer,'login logout register',view.render);
            view.listenTo(customer,'change:firstname change:lastname',view.onChangeCustomerName);

        },

        render:function(ignoreRetemplating){

            var cartStore = app.getCartStore(),
                customer = app.getCustomer();

            if(ignoreRetemplating !== true){
                var contentHtml = mainHeaderTemplate({
                    img_url:site_vars.img_url,
                    account_rewrites:{
                        loyalty: app.c('_ACCOUNT_LOYALTY_REWRITE_'),
                        orders: app.c('_ACCOUNT_ORDERS_REWRITE_'),
                        favorites: app.c('_ACCOUNT_FAVORITES_REWRITE_')
                    },
                    languages: app.getLanguages(),
                    customer:customer,
                    reorder_enable:app.c('_REORDER_ENABLE_'),
                    store: cartStore,
                    hooks: hooks,
                    initialRender: initialRender,
                });
                if(initialRender){
                    view.$el.html(contentHtml);
                    initialRender = false;
                }else{
                    view.$('.header-main-wrapper').html(contentHtml);
                }
            }
            if(cartStore && !app.getCart().get('store_closed')){
                view.$('.store-name')
                    .text(cartStore.getFullName());
                view.$('.wrapper-link-store')
                    .attr('href',cartStore.getUrl());
            }
            view.onChangeCartQuantity();

            if(customer.isLogged())
            {
                var ordering = customer.getOrdering();
                if (ordering.size() > 0 && (view.$('.ordering > div').length === 0)) {
                    ordering.each(function (order) {

                        var orderingView = view.attachView(new OrderTrackingView({
                            order: order,
                            tracking: true,
                        }));
                        view.$('.ordering').append(orderingView.el);
                        view.$('.header-ordering').addClass('active');
                    });
                }

            }
            view.getLastOrders();
            view.delegateEvents();
            view.attachViews(SelectView.initializeSelectsOfView(view));
            InternalLinkView.initializeLinksOfView(view);
        },

        inputFocus:function(){
            storeLocatorSearchCollection.initStoreLocator();
            view.onSearchResults();
        },
        inputFocusOut:_.debounce(function(){
            view.$('.autocomplete-results').html('');
        },100),

        inputChange:_.debounce(function(e){
          var inputString = (e.currentTarget.value || '').trim(),
              validSearch = inputString.length>2;
            view.$('.autocomplete-results').toggleClass('empty',!validSearch);
            if(validSearch){
                storeLocatorSearchCollection.search(inputString);
                view.onSearchResults();
            }
        },300),

        onSearchResults:function(e){
            var view = this, html = '', searchCollection = storeLocatorSearchCollection;
            if(searchCollection.size()===0){
                searchCollection = searchCollection.getEmptyCollection();
            }
            searchCollection.each(function(searchModel,i){
                if(i<10){
                    html += StoreAutocompleteResultTemplate(searchModel.toJSON());
                }
            })
            var results = view.$('.autocomplete-results');
            results.html(html);
            InternalLinkView.initializeLinksOfEl(results.get(0));
        },

        switchLang:function(e) {
            var option = view.$('.lang-select option:selected'),
                iso = option.val();
            TagCommander.eventGA(e.currentTarget,'header','language',iso);
            window.location= site_vars.base_url + iso.toLowerCase() + '/';
        },
        onChangeCartQuantity:function(cart){
            var quantity = app.getCart().getQuantity();
            quantity = quantity>100 ? '+':quantity;
            view.$('.cart-product-count').text(quantity).attr('data-count',quantity);
        },

        onChangeCustomerName:function(customer){
            view.$('.customer-fullname').text(customer.getFullname());
        },

        show: function(){
            view.$el.removeClass('inactive semi-inactive');
        },

        hide: function(){
            view.$el.addClass('inactive');
        },

        touchmoveWrapper:function(e){
            var view = this,
                newTouchmoveY = e.originalEvent.touches[0].clientY;
            var $reoderWrapper = view.$('.reorder-wrapper__orders'),
                $reorderMaxScroll = $reoderWrapper.prop('scrollHeight') - $reoderWrapper.innerHeight();

            if(touchmoveDeltaY > 80){
                // on touch up
                if($reorderMaxScroll === 0){
                    view.$('.header-wrapper').removeClass('active');
                    view.$('.active-link').removeClass('active-link');
                }
                touchmoveY = false;
                touchmoveDeltaY = 0;
            }else if($reorderMaxScroll === 0){
                if(touchmoveY){
                    touchmoveDeltaY += touchmoveY - newTouchmoveY;
                }
                touchmoveY = newTouchmoveY;
                e.preventDefault();
            }
        },
        touchendWrapper:function(e){
            touchmoveY = false;
            touchmoveDeltaY = 0;
        },

        openSideNav: function(e){
            app.trigger('openSideNav');
        },

        openAutocomplete: function(e){
            app.displayModal(new AddressAutocompleteView({type:'store',theme:'modal', ignoreInitialSelection:true}));
        },

        toggleWrapper: function(e){
            e.preventDefault()
            view.$('.header-wrapper').toggleClass('active');
        },
        openWrapper: function(e){
            var view = this,
                btnTarget = $(e.currentTarget),
                isMobile = app.isMobile(),
                wrapperClass = btnTarget.data('wrapper');
            if(isMobile && e.type==='mouseenter') return;
            if(isMobile){
             if(wrapperClass !== 'reorder-wrapper'){
                 view.$('[data-link="Reorder"]').removeClass('active-link');
                 view.$('.reorder-wrapper').removeClass('active');
             }
            }
            if ($('.notifications.notice').length && $('.notifications.notice').isInViewport()) return;
            setTimeout(function(){
                if (btnTarget.is(':hover')) {
                    var targetWrapper = view.$('.' + wrapperClass),
                        isActive = targetWrapper.is('.active');
                    view.$('.header-wrapper').removeClass('active');
                    targetWrapper.toggleClass('active',!isActive);
                    btnTarget.parent().toggleClass('active-link',!isActive);
                    touchmoveY = false;
                    touchmoveDeltaY = 0;
                }
            }, 200);
        },
        submitStoreSearch:function(e){
            e.preventDefault();
            var search = view.$('.search-store-location').val();
            app.go('storeLocatorSearch',{search:search});
        },

        closeWrapper: function(e){
            var $currentTarget = $(e.currentTarget),
                target = $currentTarget.hasClass('header-wrapper') ? $currentTarget : $currentTarget.closest('.header-wrapper');
            target.removeClass('active');
        },

        onPageChange: function(name,displayAsModal){
            view.$('[data-link]').removeClass('active-link').filter(function() {
                var dataLinks = $(this).attr('data-link');
                if(dataLinks){
                    return $.inArray(name, dataLinks.split(':')) >= 0 ? true : false;
                }else{
                    return false;
                }
            }).addClass('active-link');
            if(!displayAsModal){
                view.$el.attr('data-pagename',name);
            }
            view.$('.header-wrapper').removeClass('active');
        },
        clickListingLink:function(e){
            //
            // au clic sur "Carte" on teste les options de livraison
            //
            e.preventDefault();
            e.stopPropagation();

            var cart = app.getCart();

            if (!cart.validateDeliveryOptions()) {
                // si c'est KO, alors on ouvre l'autocomplete address
                cart.requireDeliveryOptions('all', false, function(validate){
                    if(!validate && app.isDeliveryOptionsRequired()){
                        // si on ne valide pas et qu'on est en mode "obligatoire" on ferme la popin
                        // et on reste sur la page
                        return;
                    }
                    app.go('listing');
                });
            }else{
                // si c'est OK, on redirige vers le listing
                app.go('listing');
            }
        },

        trackLink:function(e){
           var currentTarget = e.currentTarget;
            TagCommander.eventGA(currentTarget,'Header','Click',$(currentTarget).data('link'));
        },
        // loadOrders: function() {
        //     var view = this;
        //     view.listenTo(app, 'allOrderLoad', view.getLastOrders);
        //     app.getCustomer().loadAllOrders()
        // },
        getLastOrders: function() {
            var view = this,
                customer = app.getCustomer(),
                orders = customer.getLastReorderOrders(),
                selectedOrders = 0;


            if(!customer.isLogged()){
                return
            }

            view.$('.reorder-wrapper__orders').html('');

            if (orders.length <= 0) {
                return view.$('.reorder-wrapper__orders').append('<p class="no-order">' + t('Acune commande à repasser', 'Navigation') + '</p>')
            }

            orders.each(function(order) {
                var reorderView = view.attachView(new ReorderOrderSingleView({order:order}))
                view.$('.reorder-wrapper__orders').append(reorderView.el)
            })
        },
    });
});

